module.exports = __webpack_public_path__ + "img/activity4.1baf2113.jpg";